import { render, staticRenderFns } from "./FreeUser.vue?vue&type=template&id=895ade1c&scoped=true"
import script from "./FreeUser.vue?vue&type=script&lang=js"
export * from "./FreeUser.vue?vue&type=script&lang=js"
import style0 from "./FreeUser.vue?vue&type=style&index=0&id=895ade1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ade1c",
  null
  
)

export default component.exports